module.exports = __webpack_public_path__ + "img/pcrown_blue.2f082200.png";